// extracted by mini-css-extract-plugin
export var card = "styles-module--card--0084f";
export var cards = "styles-module--cards--26606";
export var container = "styles-module--container--c961e";
export var description = "styles-module--description--802ce";
export var icon = "styles-module--icon--73943";
export var title = "styles-module--title--f5392";